import { useStore } from "../../../store";
import { toJS } from "mobx";
import DateTime from "../../../components/DateTime";
import Switch from "react-switch";
import MySelect from "../../../components/MySelect";

function MeunSettingScreensaver() {
  const { dataStore } = useStore();
  const resData = toJS(dataStore).resData;

  let onClickTimeHandle = function (value: string) {
    dataStore.sendData({
      action: 'updateSetting',
      data: {
        key: 'screensaverWaitTime',
        value: value === 'Never' ? null : value
      },
    })
  };


  const onChangeScreenLockEnabled = (value: boolean) => {
    dataStore.sendData({
      action: 'updateSetting',
      data: {
        key: 'screenLockEnabled', value
      }
    })
  }

  return (
    <div className="w-4/6 relative mr-10">
      <div className="border-2 rounded-2xl absolute inset-0 m-auto h-4/6 opacity-1 mr-10"
        style={{
          backgroundColor: 'rgba(212,115,0,0.5)',
          boxShadow: "8px 8px 8px  rgba(0, 0, 0, 0.3)",
        }}
      >

        <div className="h-[500px] overflow-auto m-10" >


          <div className="h-12 px-28">
            <span className="float-left text-white text-3xl mt-1">
              Screensaver
            </span>
            <div
              className="mt-[7px] float-right"
              style={{
                width: 110,
                flexDirection: 'row',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Switch
                onChange={onChangeScreenLockEnabled}
                checked={!!resData.loadSettingAck?.screenLockEnabled}
                uncheckedIcon={false}
                checkedIcon={false}
                onColor={"#5ede4e"}
              />
            </div>
          </div>


          <div className="h-12 px-28">
            <span className="float-left text-white text-3xl mt-1">
              Theme
            </span>
            <MySelect
              value={{ value: 'Carrot', label: 'Carrot' }}
              options={[{ value: 'Carrot', label: 'Carrot' }]}
              className="w-[130px] float-right mt-[1px]"
            // onChange={e => onChangeTimezone(e.value)}
            />
          </div>

          <br></br>
          <div className="h-12 px-28" >
            <span className="float-left text-white text-3xl mt-[70px]">
              Waiting Time
              <span style={{ marginLeft: 10 }}>(min)</span>
            </span>
            <DateTime
              options={{
                type: "countdown",
                cb: (value) => {
                  onClickTimeHandle(value);
                },
                defaultValue: String(resData.loadSettingAck?.screensaverWaitTime || 5),
              }}
              style={{
                position: 'absolute',
                right: 0,
                marginRight: '150px',
                borderWidth: 1.5,
                width: 110,
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
export default MeunSettingScreensaver;
